// Pull a display URL out of the CMS's polymorphic image field.
//
// The API hands back one of three shapes depending on how the record was
// created: {url}, {url, formats:{…}}, or a bare string. Prefer the medium
// format when there is one — the originals are multi-megabyte 2K PNGs, and a
// hero grid tile renders at ~300px.
export function coverUrl(item: any): string | undefined {
  const img = item?.image
  if (!img) return undefined
  if (typeof img === 'string') return img
  return img.formats?.medium?.url || img.url || undefined
}

/** The first `count` items that actually have artwork — for a hero grid. */
export function coversFrom(items: any[] | undefined, count = 4): string[] {
  return (items ?? [])
    .map(coverUrl)
    .filter((u): u is string => Boolean(u))
    .slice(0, count)
}
